import { makeStyles } from "@material-ui/core";
import {
	DEFAULT_BOX_SHADOW,
	instance1,
	instance2,
	PRIMARY_BACKGROUND,
} from "App/constants";
import { cantNullEmptyAndUndefined } from "App/utils/helpers";
import { isEmpty } from "lodash";
import { useEffect, useState } from "react";

export const urlDeleteOrganisasi = "/master-satu-sehat/organization/delete";
export const urlGetOrganisasi = "/master-satu-sehat/organization/list";
export const urlGetLokasi = "/master-satu-sehat/location/list";
export const urlPostOrganisasi = "/master-satu-sehat/organization/add";
export const urlUpdateOrganisasi = "/master-satu-sehat/organization/update";

export const deleteOrganisasi = async (id) => {
	try {
		const api = await instance1.post(urlDeleteOrganisasi, {
			id_organization: id,
		});
		return {
			state: true,
			message: api.data.message,
		};
	} catch (error) {
		return {
			state: false,
			message: error?.response?.data?.message,
		};
	}
};

export const headCellsOrganisasi = [
	{
		id: "no",
		disablePadding: false,
		label: "NO",
		align: "center",
		sort: false,
		minWidth: "40px",
	},
	{
		id: "act",
		disablePadding: true,
		label: "ACT",
		sort: false,
		align: "center",
	},
	{
		id: "kode",
		disablePadding: true,
		label: "KODE",
		align: "left",
		minWidth: "100px",
	},
	{
		id: "name",
		disablePadding: false,
		label: "NAMA",
		align: "left",
		minWidth: "120px",
	},
	{
		id: "alias",
		disablePadding: false,
		label: "ALIAS",
		align: "left",
		minWidth: "150px",
	},
	{
		id: "active",
		disablePadding: false,
		label: "STATUS",
		align: "center",
		minWidth: "100px",
	},
	{
		id: "inserted_time",
		disablePadding: false,
		label: "INSERTED TIME",
		sort: false,
		minWidth: "170px",
	},
	{
		id: "inserted_by",
		disablePadding: false,
		label: "INSERTED BY",
		sort: false,
		minWidth: "150px",
	},
	{
		id: "updated_time",
		disablePadding: false,
		label: "UPDATED TIME",
		sort: false,
		minWidth: "170px",
	},
	{
		id: "updated_by",
		disablePadding: false,
		label: "UPDATED BY",
		sort: false,
		minWidth: "150px",
	},
];

export const headCellsLokasi = [
	{
		id: "no",
		disablePadding: false,
		label: "NO",
		align: "center",
		sort: false,
		minWidth: "40px",
	},
	{
		id: "act",
		disablePadding: true,
		label: "ACT",
		sort: false,
		align: "center",
	},
	{
		id: "kode",
		disablePadding: true,
		label: "KODE",
		align: "left",
		minWidth: "100px",
	},
	{
		id: "name",
		disablePadding: false,
		label: "NAMA",
		align: "left",
		minWidth: "120px",
	},
	{
		id: "description",
		disablePadding: false,
		label: "DESCRIPTION",
		align: "left",
		minWidth: "150px",
	},
	{
		id: "status",
		disablePadding: false,
		label: "STATUS",
		align: "left",
	},
	{
		id: "mode",
		disablePadding: false,
		label: "MODE",
		align: "left",
	},

	{
		id: "type",
		disablePadding: false,
		label: "TIPE",
		align: "left",
	},
	{
		id: "inserted_time",
		disablePadding: false,
		label: "INSERTED TIME",
		sort: false,
		minWidth: "170px",
	},
	{
		id: "inserted_by",
		disablePadding: false,
		label: "INSERTED BY",
		sort: false,
		minWidth: "150px",
	},
	{
		id: "updated_time",
		disablePadding: false,
		label: "UPDATED TIME",
		sort: false,
		minWidth: "170px",
	},
	{
		id: "updated_by",
		disablePadding: false,
		label: "UPDATED BY",
		sort: false,
		minWidth: "150px",
	},
];

export const RESET_STATE_ORGANISASI = {
	id_organization: "",
	parent_id_organization: "",
	id_location: "",
	kode: "",
	name: "",
	alias: "",
	identifier: [],
	active: "",
	type: "",
	telecom: [],
	use: "",
	address: [],
	line: "",
	city: "",
	postalCode: "",
	country: "",
	extension: "",
	url: "",
	valueCode: "",
	id: "",
	partOf_parent_id: "",
	nama_loction: "",
	pages: 1,
	limit: 10,
};

export const headCellsKontak = [
	{
		id: "no",
		disablePadding: false,
		label: "NO",
		align: "center",
		sort: false,
		minWidth: "40px",
	},
	{
		id: "act",
		disablePadding: true,
		label: "ACT",
		sort: false,
		align: "center",
	},
	{
		id: "tipe",
		disablePadding: true,
		label: "TIPE KONTAK",
		align: "left",
		minWidth: "100px",
	},
	{
		id: "kontak",
		disablePadding: false,
		label: "INPUTAN KONTAK",
		align: "left",
		minWidth: "120px",
	},
];

export const getOrganisasi = async (formFilter, pages, limit) => {
	try {
		const api = await instance1.get(
			`${urlGetOrganisasi}?limit=${limit}&pages=${pages}&parent_id_organization=${formFilter.parent_id_organization}&name=${formFilter.name}`
		);
		const res = api.data;
		return {
			state: true,
			message: res.message,
			body: res.body,
			count: res.count,
			sisa: res.sisa,
			limit: res.limit,
			pages: res.pages,
		};
	} catch (error) {
		return {
			state: false,
			message: error?.response?.data?.message,
		};
	}
};

export const STATE_INFO = {
	id_organization: "",
	parent_id_organization: "",
	kode: "",
	name: "",
	alias: "",
	active: true,
	isUpdate: false,
	id: "",
};

export const STATE_LOKASI = {
	id_lokasi: "",
	nama: "",
};

export const STATE_ALAMAT = {
	available: false,
	use: "",
	type: "",
	line: "",
	postalCode: "",
	country: "",
	url: "",
	province: "",
	province_name: "Pilih Provinsi",
	city: null,
	city_name: "Pilih Kota",
	district: "",
	district_name: "Pilih Kecamatan",
	sub_district: "",
	sub_district_name: "Pilih Kelurahan",
};

export const STATE_KONTAK = {
	available: false,
	system: "",
	value: "",
	use: "",
};

export const STYLE_MASTER_SATU_SEHAT_ORGANISASI = makeStyles({
	root: {
		width: "auto",
	},
	paper: {
		width: "100%",
		margin: "0",
		padding: "1rem 1.5rem",
		backgroundColor: PRIMARY_BACKGROUND,
		boxShadow: DEFAULT_BOX_SHADOW,
	},
	table: {
		width: "100%",
		margin: "0 auto",
		overflow: "auto",
	},
});

export const RESET_STATE_LOKASI = {
	id_location: "",
	parent_id_location: "",
	kode: "",
	name: "",
	description: "",
	status: "",
	mode: "",
	type: "",
	operationalStatus: "",
	telecom: [],
	physicalType: [],
	managingOrganization: [],
	id: "",
	partOf_parent_id: "",
	hoursOfOperation: [],
	availabilityExecptions: "",
	position: [],
	address: [],
	identifier: "",
	phone: "",
	fax: "",
	email: "",
	pager: "",
	url: "",
	other: "",
	pages: 1,
	limit: 10,
};

export const getLokasi = async (formFilter, pages, limit) => {
	try {
		const api = await instance1.get(
			`${urlGetLokasi}?limit=${limit}&pages=${pages}&parent_id_location=${formFilter.parent_id_location}&name=${formFilter.name}`
		);
		const res = api.data;
		return {
			state: true,
			message: res.message,
			body: res.body,
			count: res.count,
			sisa: res.sisa,
			limit: res.limit,
			pages: res.pages,
		};
	} catch (error) {
		return {
			state: false,
			message: error?.response?.data?.message,
		};
	}
};

export const selectTelecomOrganisasi = [
	{
		value: "",
		label: "Pilih Tipe Kontak",
	},
	{
		value: "phone",
		label: "Telepon",
	},
	{
		value: "fax",
		label: "FAX",
	},
	{
		value: "email",
		label: "Email",
	},
	{
		value: "pager",
		label: "Pager",
	},
	{
		value: "url",
		label: "Url",
	},
	{
		value: "sms",
		label: "SMS",
	},
	{
		value: "other",
		label: "Lainnya....",
	},
];

export const selectAlamatOrganisasi = [
	{
		value: "",
		label: "Pilih Alamat Organisasi",
	},
	{
		value: "postal",
		label: "Alamat Untuk Surat",
	},
	{
		value: "physical",
		label: "Alamat Yang Bisa Dikunjungi",
	},
	{
		value: "both",
		label: "Alamat Untuk Surat dan Yang Bisa Dikunjungi",
	},
];

export const useCity = (id) => {
	const DEFAULT_OPTION = [];
	const [state, setState] = useState(DEFAULT_OPTION);

	const get = async () => {
		try {
			const api = await instance2.get("/alamat/list_kota_byprop", {
				headers: {
					ms_locpropinsi_id: id,
				},
			});

			const res = api.data;
			return res.body;
		} catch (error) {
			return [];
		}
	};

	useEffect(() => {
		(async () => {
			if (cantNullEmptyAndUndefined(id)) {
				const res = await get();
				if (res) {
					const data = [];

					res.map((item) => {
						return data.push({
							value: `${item.id}`,
							label: `${item.name}`,
						});
					});

					setState(data);
				}
			}
		})();
	}, [id]); // eslint-disable-line react-hooks/exhaustive-deps

	return state;
};

export const useDistrict = (id) => {
	const DEFAULT_OPTION = [];

	const [state, setState] = useState(DEFAULT_OPTION);

	const get = async () => {
		try {
			const api = await instance2.get("/alamat/list_kecamatan_bykota", {
				headers: {
					ms_lockota_id: id,
				},
			});
			const res = api.data;
			return res.body;
		} catch (error) {
			console.log(error?.response);
			return [];
		}
	};

	useEffect(() => {
		(async () => {
			if (!isEmpty(id)) {
				const res = await get();
				if (res) {
					const data = [];

					res.map((item) => {
						return data.push({
							value: `${item.id}`,
							label: `${item.name}`,
						});
					});

					setState(data);
				}
			}
		})();
	}, [id]); // eslint-disable-line react-hooks/exhaustive-deps

	return state;
};

export const useSubDistrict = (id) => {
	const DEFAULT_OPTION = [];

	const [state, setState] = useState(DEFAULT_OPTION);

	const get = async () => {
		try {
			const api = await instance2.get("/alamat/list_kelurahan_bykec", {
				headers: {
					ms_lockecamatan_id: id,
				},
			});
			const res = api.data;
			return res.body;
		} catch (error) {
			return [];
		}
	};

	useEffect(() => {
		(async () => {
			if (!isEmpty(id)) {
				const res = await get();
				if (res) {
					const data = [];

					res.map((item) => {
						return data.push({
							value: `${item.id}`,
							label: `${item.name}`,
						});
					});

					setState(data);
				}
			}
		})();
	}, [id]); // eslint-disable-line react-hooks/exhaustive-deps

	return state;
};

export const headCellsAlamat = [
	{
		id: "no",
		disablePadding: false,
		label: "NO",
		align: "center",
		sort: false,
		minWidth: "40px",
	},
	{
		id: "act",
		disablePadding: true,
		label: "ACT",
		sort: false,
		align: "center",
	},
	{
		id: "line",
		disablePadding: true,
		label: "ALAMAT",
		align: "left",
		minWidth: "100px",
	},
	{
		id: "postalCode",
		disablePadding: true,
		label: "KODE POS",
		align: "left",
		minWidth: "100px",
	},
	{
		id: "province",
		disablePadding: true,
		label: "PROVINSI",
		align: "left",
		minWidth: "100px",
	},
	{
		id: "city",
		disablePadding: true,
		label: "KOTA",
		align: "left",
		minWidth: "100px",
	},
	{
		id: "district",
		disablePadding: true,
		label: "KECAMATAN",
		align: "left",
		minWidth: "100px",
	},
	{
		id: "sub_district",
		disablePadding: true,
		label: "KELURAHAN",
		align: "left",
		minWidth: "100px",
	},
];

export const postOrganisasi = async (
	parent_id_organization,
	kode,
	name,
	alias,
	partOf_parent_id,
	id_location,
	telecom,
	active,
	address
) => {
	try {
		const api = await instance1.post(`${urlPostOrganisasi}`, {
			parent_id_organization: parent_id_organization,
			kode: kode,
			name: name,
			alias: alias,
			partOf_parent_id: partOf_parent_id,
			id_location: id_location,
			telecom: telecom,
			active: active,
			address: address,
		});
		const res = api.data;
		return {
			state: true,
			message: res.message,
			body: res.body,
			count: res.count,
			sisa: res.sisa,
			limit: res.limit,
			pages: res.pages,
		};
	} catch (error) {
		return {
			state: false,
			message: error?.response?.data?.message,
		};
	}
};

export const updateOrganisasi = async (
	id_organization,
	parent_id_organization,
	kode,
	name,
	alias,
	partOf_parent_id,
	id_location,
	telecom,
	active,
	address
) => {
	try {
		const api = await instance1.post(`${urlUpdateOrganisasi}`, {
			id_organization: id_organization,
			parent_id_organization: parent_id_organization,
			kode: kode,
			name: name,
			alias: alias,
			partOf_parent_id: partOf_parent_id,
			id_location: id_location,
			telecom: telecom,
			active: active,
			address: address,
		});
		const res = api.data;
		return {
			state: true,
			message: res.message,
			body: res.body,
			count: res.count,
			sisa: res.sisa,
			limit: res.limit,
			pages: res.pages,
		};
	} catch (error) {
		return {
			state: false,
			message: error?.response?.data?.message,
		};
	}
};
